// extracted by mini-css-extract-plugin
export default {"dropdown":"Filters_dropdown__FnG9j"};